import { useDispatch } from 'react-redux';
import { clearNotificaciones, showSideBar } from '../../../redux/slices';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import NotificacionesService from 'Services/Http/Notificaciones.service';
import Button from '../../../Components/Button';

const Notificaciones = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [cards, setCards] = useState([]);
  const [ids, setIds] = useState([]);
  const [disabled, setDisabled] = useState(true);

  useEffect(() => {
    dispatch(showSideBar(false));
    getNotificaciones();
    setDisabled(true);
    setTimeout(() => {
      setDisabled(false);
    }, 30000);
    return () => {
      dispatch(showSideBar(true));
    };
  }, []);

  const completeNotificationes = () => {
    dispatch(clearNotificaciones());
  };

  const onClick = async () => {
    try {
      await NotificacionesService.saveNotificaciones({ ids });
      completeNotificationes();
      dispatch(showSideBar(true));
      navigate('/');
    } catch (e) {
      console.log(e);
    }
  };
  const getNotificaciones = async () => {
    try {
      const response = await NotificacionesService.getNotificacion();
      const identifiers = await response.data.map((notificacion) => notificacion.id);
      setIds(identifiers);
      const cardsData = response.data.map((notificacion) => {
        let type = '';
        switch (notificacion.tipo) {
          case '2':
            type = 'urgente';
            break;
          case '3':
            type = 'informacion';
            break;
        }
        return (
          <div
            key={`notfId_${notificacion.id}`}
            className={`notificacion-base ${type}`}
            role="alert">
            <div className="flex w-1/12 justify-center items-center">
              <strong className="font-bold">{notificacion.id}</strong>
            </div>
            <div className="flex flex-col w-11/12">
              <div className="font-bold">{notificacion.title}</div>
              <div>{notificacion.descripcion}</div>
            </div>
          </div>
        );
      });
      setCards(cardsData);
      if (cardsData.length === 0) {
        completeNotificationes();
        dispatch(showSideBar(true));
        navigate('/');
      }
    } catch (e) {
      console.log(e);
    }
  };
  return (
    <>
      {cards}
      <Button onClick={onClick} label="He leído las notificaciones" disabled={disabled} />
    </>
  );
};

export default Notificaciones;
